// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/base.css
// module id = +BTi
// module chunks = 4